<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button
        (click)="dismiss()"
        ngxTippy
        [tippyProps]="{
          arrow: false,
          placement: 'bottom'
        }"
        data-tippy-content="Back to conversation"
      >
        <ion-icon
          name="chevron-back-outline"
          class="icon-padded-right"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title class="hidden-sm" *ngIf="conversation">
      Microsoft Teams message content in conversation
      {{ conversation?.friendlyId ? "#" + conversation?.friendlyId : "" }}
    </ion-title>
    <ion-title class="hidden-sm" *ngIf="!conversation"
      >Microsoft Teams message content
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid style="padding: 0">
    <ion-row>
      <ion-col
        size-xl="9"
        size-lg="8"
        size-md="6"
        size="12"
        style="min-height: calc(100vh - 112px); padding: 0"
      >
        <div
          style="text-align: center; padding-top: 40px"
          *ngIf="!microsoftTeamsMessage"
        >
          <ion-spinner name="crescent"></ion-spinner>
        </div>
      </ion-col>
      <ion-col size-md="6" size-xl="3" size-lg="4" size="12" class="right-col">
        <div
          style="text-align: center; padding-top: 40px"
          *ngIf="!microsoftTeamsMessage"
        >
          <ion-spinner name="crescent"></ion-spinner>
        </div>
        <div class="right-menu">
          <h3 style="margin: 15px 15px 0 15px; font-size: 1.1rem">
            Message Details
          </h3>
          <ion-list
            class="transparent-bg"
            lines="none"
            *ngIf="microsoftTeamsMessage"
          >
            <ion-item>
              <ion-label text-wrap>
                <p>From</p>
                <h3>
                  {{ microsoftTeamsMessage.user.email }}
                </h3>
              </ion-label>
            </ion-item>
            <ion-item>
              <ion-label text-wrap>
                <p>Received at</p>
                <h3>
                  {{
                    microsoftTeamsMessage.inbound.timestamp
                      | date: "MMM d yyyy h:mm a"
                  }}
                </h3>
              </ion-label>
            </ion-item>
            <ion-item *ngIf="microsoftTeamsMessage.attachments?.length">
              <ion-label text-wrap>
                <p>
                  Attachments ({{ microsoftTeamsMessage.attachments.length }})
                </p>
                <ul style="margin: 0; padding: 0 0 0 15px">
                  <ng-container
                    *ngFor="let attachment of microsoftTeamsMessage.attachments"
                  >
                    <li>
                      <a
                        (click)="downloadAttachment(attachment.slackId)"
                        *ngIf="attachment.slackId"
                      >
                        {{ attachment.filename }}
                      </a>
                      <span>{{ attachment.filname }}</span>
                    </li>
                  </ng-container>
                </ul>
              </ion-label>
            </ion-item>
          </ion-list>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
